import { styled } from '@mui/material';
import { Container, Item } from 'Components/Grid';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { useAppDispatch, useAppSelector } from 'Store/index';
import { actions } from 'Store/messaging';
import { TTOPIC } from 'Store/messaging/types/TTopic';
import { hasPatientData } from '.';
import colors from '../../../config/theme/colors';

const StyledNamesArea = styled('div')({
  width: '100%',
  height: 'auto',
  maxHeight: '40rem',
  overflow: 'auto',
  border: '0.1rem solid ' + colors.gray,
});

interface IPatientData {
  lastNames: string;
  firstNames: string;
  id: string;
}

const PatientList = ({ topic, patientIdList }: IPatientList) => {
  const patientNamesForTopics = useAppSelector(s => s.messaging.patientNames);
  const patientNamesForThisTopic: IPatientData[] | null | undefined =
    topic?.targetPatients && hasPatientData(topic?.targetPatients)
      ? topic?.targetPatients
      : patientNamesForTopics?.[topic?.id || 'notopicid'];

  const [expand, setExpand] = React.useState<boolean>(false);

  const dispatch = useAppDispatch();
  React.useEffect(() => {
    if ((expand || !patientNamesForThisTopic) && topic) {
      if (!hasPatientData(topic.targetPatients) && topic.targetPatients.length > 0) {
        dispatch(actions.loadPatientNames(topic.targetPatients, topic.id, 'messaging patient list for specific topic'));
      }
    }
    if ((expand || !patientNamesForThisTopic) && patientIdList)
      if (patientIdList.length > 0) {
        dispatch(actions.loadPatientNames(patientIdList, 'notopicid', 'messaging patient list'));
      }
  }, [expand]);

  React.useEffect(() => {
    return () => {
      dispatch(actions.loadPatientNamesAction({ ['notopicid']: null }));
    };
  }, []);

  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  return !expand ? (
    <div style={{ fontWeight: 600 }} className="link" onClick={() => setExpand(true)}>
      {fm('messaging.showPatients')}
    </div>
  ) : (
    <>
      <div style={{ fontWeight: 600, marginBottom: '0.5rem' }} className="link" onClick={() => setExpand(false)}>
        {fm('messaging.hidePatients')}
      </div>
      <StyledNamesArea>
        {(patientNamesForThisTopic || []).map((name, index) => (
          <Container
            key={name.id}
            style={{
              padding: '0.2rem 0.5rem',
              backgroundColor: index % 2 === 0 ? colors.lightestGray : undefined,
            }}
          >
            <Item style={{ marginRight: '0.5rem' }}>{name.lastNames}</Item>
            <Item>{name.firstNames}</Item>
          </Container>
        ))}
      </StyledNamesArea>
    </>
  );
};

interface IPatientList {
  topic?: TTOPIC;
  patientIdList?: string[];
}

export default PatientList;
